module.exports = require('./normalizeArray')
